import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import * as Sentry from '@sentry/browser';

import { RootState } from 'app/redux/store';

import { AuthState, AuthApiResponse } from '../types';

const initialState: AuthState = {
  isLogged: false,
  loginChecked: false,
  redirectUrl: null,
  token: {
    type: '',
    token: '',
    expiresAt: '',
  },
  fullName: '',
  loginEmail: '',
  preferredTimezone: '',
  backOfficeAccess: false,
  roles: undefined!,
  permissions: undefined!,
  customerUuid: '',
  studentUuid: '',
  accountUuid: '',
  sso: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthProcess(state, action: PayloadAction<AuthApiResponse>) {
      const { token, fullName, preferredTimezone, backOfficeAccess, roles, permissions, customerUuid, studentUuid, accountUuid, sso, loginEmail } =
        action.payload;

      // TODO: Obter UUID do usuário para o GA

      state.isLogged = true;
      state.loginChecked = true;
      state.token = token;
      state.fullName = fullName;
      state.loginEmail = loginEmail;
      state.preferredTimezone = preferredTimezone;
      state.backOfficeAccess = backOfficeAccess;
      state.roles = roles;
      state.permissions = permissions;
      state.customerUuid = customerUuid;
      state.studentUuid = studentUuid;
      state.accountUuid = accountUuid;
      state.sso = sso;

      // Sentry.setUser({ username: fullName });
    },

    clearAuthProcess(state) {
      state.isLogged = initialState.isLogged;
      state.loginChecked = initialState.loginChecked;
      state.token = initialState.token;
      state.fullName = initialState.fullName;
      state.loginEmail = initialState.loginEmail;
      state.preferredTimezone = initialState.preferredTimezone;
      state.backOfficeAccess = initialState.backOfficeAccess;
      state.roles = initialState.roles;
      state.permissions = initialState.permissions;
      state.customerUuid = initialState.customerUuid;
      state.studentUuid = initialState.studentUuid;
      state.accountUuid = initialState.accountUuid;
      // Sentry.configureScope((scope) => scope.setUser(null));
    },

    setLoggedProcess(state, action: PayloadAction<boolean>) {
      state.isLogged = action.payload;
    },

    setRedirectUrlProcess(state, action: PayloadAction<string | null>) {
      state.redirectUrl = action.payload;
    },

    setLoginCheckedProcess(state, action: PayloadAction<boolean>) {
      state.loginChecked = action.payload;
    },
  },
});

export const { setAuthProcess, clearAuthProcess, setLoggedProcess, setRedirectUrlProcess, setLoginCheckedProcess } = authSlice.actions;

export const getAuth = (state: RootState): AuthState => state.auth;

export default authSlice.reducer;
